import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { InvoicesByCounterpartyItem } from "@common/types/invoice";
import { Entity } from "@common/types/entity";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useEntitiesById } from "@hooks/useEntities";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";

export const EntitiesCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, InvoicesByCounterpartyItem, any>) => {
        const item = row.original;
        const entities = useEntitiesById();

        const getEntities = useCallback(
            (entityIds: number[]) =>
                entityIds.map((entityId) => entities.get(entityId) as Entity),
            [entities],
        );

        return (
            <ViewTableCell>
                <EntityAvatarGroup
                    entities={getEntities(item.entityIds)}
                    max={3}
                />
            </ViewTableCell>
        );
    },
);
